import { render, staticRenderFns } from "./banner-accept.vue?vue&type=template&id=2100d290"
import script from "./banner-accept.vue?vue&type=script&lang=js"
export * from "./banner-accept.vue?vue&type=script&lang=js"
import style0 from "./banner-accept.vue?vue&type=style&index=0&id=2100d290&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports